import { colors } from "../../../styles/figmaColors";
import { useTranslation } from "react-i18next";
import { Tag } from "../Tag/Tag";
import "../../../../i18n/i18n";

export type HomeChargingSupportingDocumentStatus =
  | "TO_CREATE"
  | "CREATED"
  | "NOTHING_TO_CREATE"
  | "CURRENT_MONTH";

const statusProps: Record<
  HomeChargingSupportingDocumentStatus,
  { backgroundColor: string; textColor: string }
> = {
  TO_CREATE: {
    backgroundColor: colors["colors/system/warning/warning_ultraLight"],
    textColor: colors["colors/system/warning/warning_normal"],
  },
  CREATED: {
    backgroundColor: colors["colors/system/success/success_ultraLight"],
    textColor: colors["colors/system/success/success_normal"],
  },
  NOTHING_TO_CREATE: {
    backgroundColor: colors["colors/surfaces/background/background_level2"],
    textColor: colors["colors/text/darkGrey"],
  },
  CURRENT_MONTH: {
    backgroundColor: colors["colors/system/informative/informative_ultraLight"],
    textColor: colors["colors/system/informative/informative_normal"],
  },
};

interface TableTagHomeChargingSupportingDocumentStatusProps {
  status: HomeChargingSupportingDocumentStatus;
  createdAt: string | null;
  createdBy: { firstName: string; lastName: string } | null;
}

const formatDayMonth = (date: Date) =>
  new Intl.DateTimeFormat("fr", {
    day: "2-digit",
    month: "2-digit",
  }).format(date);

export const TableTagHomeChargingSupportingDocumentStatus = (
  props: TableTagHomeChargingSupportingDocumentStatusProps,
) => {
  const { t } = useTranslation();
  const { backgroundColor, textColor } = statusProps[props.status];

  return (
    <Tag
      text={t(
        props.status === "CREATED" && !props.createdBy
          ? "home_charging_supporting_documents.status.CREATED_WITHOUT_AUTHOR"
          : `home_charging_supporting_documents.status.${props.status}`,
        {
          date: props.createdAt && formatDayMonth(new Date(props.createdAt)),
          author:
            props.createdBy &&
            `${props.createdBy.firstName} ${props.createdBy.lastName.charAt(0)}.`,
        },
      )}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
